
export default {
    name: 'news',
    type: 'document',
    title: 'News',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: "array",
            of: [{
                type: "block",
                styles: [],
                lists: [],
                marks: {
                    decorators: [
                        { title: 'Italic', value: "em" },
                    ],
                    annotations: [],
                },

            }],
            validation: Rule => Rule.required(),
        },
        {
            title: 'Slug',
            name: 'slug',
            type: 'slug',
            validation: Rule => Rule.required(),
            options: {
                source: 'title',
                maxLength: 200, // will be ignored if slugify is set
                slugify: input => toPlainText(input)
                    .toLowerCase()
                    .replace(/(<([^>]+)>)/ig, '')
                    .replace(/\s+/g, '-')
                    .replace(/[ .,:;`'"<>?!@£$%^&*()~‘’\[\]–—]|\n|\r/g, '')
                    .replace(/-+/g, '-')
                    .slice(0, 200)
            }
        },
        {
            name: 'preview',
            title: 'Title in Ticker',
            type: "array",
            of: [{
                type: "block",
                styles: [],
                lists: [],
                marks: {
                    decorators: [
                        { title: 'Italic', value: "em" },
                    ],
                    annotations: [],
                },

            }],
        },
        {
            title: 'Start Date & Time',
            name: 'dateStart',
            type: 'datetime',
            validation: Rule => Rule.required(),
            options: {
                dateFormat: 'DD.MM.YYYY',
                timeFormat: 'HH:mm',
            }
        },
        {
            title: 'End Date & Time',
            name: 'dateEnd',
            type: 'datetime',
            options: {
                dateFormat: 'DD.MM.YYYY',
                timeFormat: 'HH:mm',

            }
        },
        {
            title: 'Show in Ticker',
            name: 'ticker',
            type: 'boolean'
        },
        {
            title: 'Show before start',
            name: 'showStart',
            type: 'boolean'
        },
        {
            title: 'Show after end',
            name: 'showEnd',
            type: 'boolean'
        },
        {
            title: "Content",
            name: "content",
            type: "array",
            of: [{
                type: "block",
                styles: [],
                marks: {
                    decorators: [
                        { value: "em" },
                    ],
                },
            }],
            validation: Rule => Rule.required(),
        },
    ],
    preview: {
        select: {
            title: 'title',
            date: 'dateStart'
        },
        prepare({ title, date }) {
            return {
                title: title ? toPlainText(title) : null,
                subtitle: date ? date.split('T')[0].split('-').reverse().join('.') : null
            }
        }
    }
}

function toPlainText(blocks = []) {
    return blocks
        // loop through each block
        .map(block => {
            // if it's not a text block with children, 
            // return nothing
            if (block._type !== 'block' || !block.children) {
                return ''
            }
            // loop through the children spans, and join the
            // text strings
            return block.children.map(child => child.text).join('')
        })
        // join the paragraphs leaving split by two linebreaks
        .join('\n\n')
}


// WEBPACK FOOTER //
// ./schemas/news.js